import { CallcardFormatterService } from '@addins/core/core';
import { IsAssignmentService } from '@addins/core/status';
import { Injectable } from '@angular/core';
import { UnitActivity } from '@models/imported/SagaSchema/UnitActivity';
import { IModelService, IObjectChange } from '@services/model-factory';
import { MyEquipmentService } from '@techwan/ionic-core';
import { MyCardReceivedTimeService } from '../../my-card-received-time/mycard-received-time.service';

@Injectable()
export class UnitActivityFusModelService implements IModelService<UnitActivity> {
  constructor(
    private myEquipment: MyEquipmentService,
    private assignment: IsAssignmentService,
    private myCardReceivedTime: MyCardReceivedTimeService,
    private callcardFormatter: CallcardFormatterService
  ) {}

  change(change: IObjectChange<UnitActivity>) {
    const unitActivity: UnitActivity = change.target;

    // myEquipment.myUnit is a behavioral subject, so we get the value immediately
    // also, if we are at this point, myEquipment.myUnit cannot be null, or we would not boot
    const myUnit = this.myEquipment.myUnit;

    // this logic should not be here
    if (myUnit.ObjGuid === unitActivity.ObjGuid && this.assignment.isRequestAssignment(unitActivity.status)) {
      this.myCardReceivedTime.setReceivedTime(unitActivity.callcard, Date.now());
      this.callcardFormatter.format(unitActivity.callcard);
    }

    unitActivity.changed(null);
  }
}
